import React, { Component } from 'react';

class BoxInfo extends Component {
  render() {
    return (
      <div className="col-12 col-md-6">
        <div className="card col-md-9">
          <div className="card-header grey darken-2 text-white">
            <div className="d-flex justify-content-between">
              <a href="#" className="btn btn-info text-uppercase">Jariyah</a>
              <h6 className="h6-responsive text-capitalize">{ this.props.data.deadline } Hari Tersisa</h6>
            </div>
            <div className="d-flex flex-column text-center mt-3">
              <h5 className="h5-responsive text-uppercase">Wakaf</h5>
              <p className="text-capitalize">Pembangunan { this.props.data.masjid_name }, { this.props.data.address }</p>
            </div>
          </div>
          <div className="card-body grey lighten-5">
            <div className="d-flex flex-column text-center mt-3 mb-3">
              <h1 className="h1-responsive text-dark"><sup>RP</sup>100</h1>
              <p className="card-text text-capitalize">Tidak ada nominal minimal</p>
              <ul className="list-unstyle text-left">
                <li className="text-capitalize">
                  <i className="fa fa-check-circle" />Investasi akhirat
                </li>
                <li className="text-capitalize">
                  <i className="fa fa-check-circle" />Bermanfaat untuk umat
                </li>
                <li className="text-capitalize">
                  <i className="fa fa-check-circle" />Pahala mengalir tanpa henti
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BoxInfo;



// WEBPACK FOOTER //
// ./src/components/BoxInfo.js